module.exports = [
  {
    id: 'commande_001',
    withdrawal_hour_start: '19h',
    withdrawal_hour_end: '21h',
    address: 'Boulangerie Louise de Halluin',
    __typename: 'Checkout',
  },
]
